import React from "react";
import { AttachmentType, AttachmentTypeDisplayNames } from "constants/field-values";
import routeNames from "constants/route-names";
import { useNavigate } from "react-router-dom";

interface DeviceAttachmentProps {
	attachment: {
		id: string;
		type: AttachmentType | string;
		name?: string;
	};
	onOpenPDF: (attachment: any) => void;
	onOpenVideo: (attachment: any) => void;
}

const DeviceAttachment: React.FC<DeviceAttachmentProps> = ({ attachment, onOpenPDF, onOpenVideo }) => {
	const navigate = useNavigate();
	let imgSrc = ``;
	let onClickAttachment;

	switch (attachment.type) {
		case AttachmentType.MANUAL:
		case AttachmentType.GENERAL_DOCUMENT:
		case AttachmentType.TECHNICAL_DOCUMENT:
			imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-manual.svg`;
			onClickAttachment = () => onOpenPDF(attachment);
			break;
		case AttachmentType.PHOTO:
		case AttachmentType.AUDIO:
		case AttachmentType.VIDEO:
			imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-video.svg`;
			onClickAttachment = () => onOpenVideo(attachment);
			break;
		case AttachmentType.DIAGRAM:
			imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-doc.svg`;
			onClickAttachment = () => onOpenPDF(attachment);
			break;
		case AttachmentType.GUIDE:
			imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/sidebar-guides-selected.svg`;
			onClickAttachment = () => navigate(routeNames.GUIDE_DETAILS.replace(":guideId", attachment.id));
			break;
		default:
			imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-doc.svg`;
			onClickAttachment = () => onOpenPDF(attachment);
	}

	return (
		<div className="device-d-attachment" onClick={onClickAttachment}>
			<div className="device-d-attachment-icon-container">
				<img alt={attachment.type} src={imgSrc} className="device-d-attachment-icon" />
			</div>
			<span className="device-d-attachment-title">{attachment.name || AttachmentTypeDisplayNames[attachment.type as AttachmentType] || attachment.type}</span>
		</div>
	);
};

export default DeviceAttachment;
